import clsx from "clsx";
import React, { PropsWithoutRef, useRef } from "react";
import {
  Tabs as BaseTabs,
  TabList as BaseTabList,
  TabPanel as BaseTabPanel,
  TabsProps as BaseTabsProps,
  TabListProps as BaseTabListProps,
  TabPanelProps as BaseTabPanelProps
} from "react-tabs";
import { useSticky } from "../useSticky";
import styles from "./Tabs.module.scss";

export type TabListProps = BaseTabListProps & {
  //spacingTop?: null | "regular" | "compact";
  //spacingBottom?: null | "regular" | "compact";
  spacingTop?: boolean;
  className?: string;
  wrapperClassName?: string;
  backgroundColor?: "titanium" | "neutral05" | "white" | "destinationLight";
  mobileSticky?: boolean;
  allBreakpointsSticky?: boolean;
};

export const TabList: React.FC<React.PropsWithChildren<TabListProps>> & {
  tabsRole: string;
} = ({
  children,
  className,
  wrapperClassName,
  spacingTop = false,
  backgroundColor = "neutral05",
  mobileSticky,
  allBreakpointsSticky
}) => {
  const stickyRef = useRef(null);
  const isSticky = useSticky(stickyRef);

  return (
    <div
      ref={stickyRef}
      className={clsx(wrapperClassName, styles.tabListContainer, {
        [styles.tabListNeutral05]: backgroundColor == "neutral05",
        [styles.tabListWhite]: backgroundColor == "white",
        [styles.tabListDestinationLight]: backgroundColor == "destinationLight",
        [styles.spacingTop]: spacingTop,
        [styles.mobileSticky]: mobileSticky,
        [styles.allBreakpointsSticky]: allBreakpointsSticky,
        [styles.listIsSticky]: isSticky
      })}
    >
      <BaseTabList className={clsx(styles.tabList, className)}>
        {children}
      </BaseTabList>
    </div>
  );
};
TabList.tabsRole = "TabList";

export type TabPanelProps = PropsWithoutRef<BaseTabPanelProps> & {
  spacingTop?: boolean;
};

export const TabPanel: React.FC<React.PropsWithChildren<TabPanelProps>> & {
  tabsRole: string;
} = ({ children, className, spacingTop, ...otherProps }) => (
  <BaseTabPanel
    className={clsx(styles.tabPanel, className, {
      [styles.tabPanelSpacingTop]: spacingTop
    })}
    selectedClassName={styles.tabPanelSelected}
    {...otherProps}
  >
    {children}
  </BaseTabPanel>
);
TabPanel.tabsRole = "TabPanel";

export type TabsProps = BaseTabsProps & {
  //
};

export const Tabs: React.FC<React.PropsWithChildren<TabsProps>> = ({
  children,
  ...props
}) => {
  return (
    <BaseTabs className={styles.tabs} {...props}>
      {children}
    </BaseTabs>
  );
};
